<template>
  <div class="active-schools">
    <h1 class="text-center my-7">مدارس تایید شده</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-data-table :headers="headers" :items="schools" :items-per-page="5">
          <template v-slot:[`item._id`]="{ item }">
            <form @submit.prevent="handleChangeDiscountPercent(item._id)">
              <div class="d-md-flex text-center pt-md-4 pb-4 pb-md-0">
                <v-text-field
                  label="درصد تخفیف"
                  type="number"
                  :id="item._id"
                  class="flex-fill"
                  dense
                ></v-text-field>
                <v-btn
                  small
                  depressed
                  rounded
                  color="success"
                  class="mt-md-1 mr-md-3"
                  type="submit"
                >
                  ثبت
                </v-btn>
              </div>
            </form>
          </template>
          <template v-slot:[`item.requestDate`]="{ item }">
            <persian-date :date="item.requestDate" />
          </template>
          <template v-slot:[`item.activeDate`]="{ item }">
            <persian-date :date="item.activeDate" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "../_Navigation.vue";
export default {
  name: "actived-schools-component",
  components: {
    Navigation
  },
  data: () => {
    return {
      schools: [],
      headers: [
        { text: "نام مدرسه", value: "title", align: "center" },
        { text: "نام مدیر", value: "moderator", align: "center" },
        { text: "نمایندگی", value: "agent.user.fullname", align: "center" },
        {
          text: "درصد تخفیف فعلی",
          value: "discountPercent",
          align: "center"
        },
        {
          text: "تغییر درصد تخفیف",
          value: "_id",
          align: "center",
          width: "250px"
        },
        { text: "نام رابط", value: "coordinator", align: "center" },
        { text: "شماره تماس", value: "mobilenumber", align: "center" },
        { text: "استان", value: "state", align: "center" },
        { text: "تاریخ درخواست", value: "requestDate", align: "center" },
        { text: "تاریخ فعال سازی", value: "activeDate", align: "center" }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api
        .get("/schools")
        .then((res) => {
          this.schools = res.data.schools;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChangeDiscountPercent(id) {
      const schoolId = id;
      const discountPercent = document.getElementById(schoolId).value;
      this.$api
        .post("/school/percent/" + schoolId, {
          discountPercent: discountPercent
        })
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
